/* eslint no-shadow: ["error", { "allow": ["Clients"] }]*/
import { createActions, handleActions } from 'redux-actions'

const defaultState = {
  error: null,
  data: null,
  isLoading: true,
  isLoadingMore: false,
}

export const {
  fetchLoginUserStart,
  fetchLoginUserSuccess,
  fetchLoginUserFail,
  loginUserReset,
} = createActions({
  FETCH_LOGIN_USER_START: (mss) => ({mss}),
  FETCH_LOGIN_USER_SUCCESS: loginUser => ({loginUser }),
  FETCH_LOGIN_USER_FAIL: error => ({ error }),
  LOGIN_USER_RESET: () => ({})
})

export const loginUser = handleActions(
  { 
    [loginUserReset]: (state) => {
    return { ...defaultState }
  },
    [fetchLoginUserStart]: state => ({
      ...state,
      error: null,
      isLoading: true
    }),
    [fetchLoginUserSuccess]: (state, { payload: { units } }) => ({
      error: null,
      isLoading: false,
      data: loginUser
    }),
    [fetchLoginUserFail]: (state, { payload: {error} }) => ({
      error,
      isLoading: false,
      data: []
    })
  },
  defaultState
)
